import React, {useCallback, useState} from "react";
import Button from "common/src/components/widget/Button";

export const ToggleSection = ({
  sectionKey,
  isHidden,
  onToggle,
  title = "Toggle",
  children,
  className = "",
}) => {
  const toggleIcon = isHidden(sectionKey) ? "down" : "up";

  const bodyClass =
      "toggle-section-body" +
      (isHidden(sectionKey) ? " is-hidden" : "") +
      (className ? ` ${className}` : "");

  return (
      <>
        <div className="level card-footer-buttons p-2 ">
          <div className={"level-left"}></div>
          <div className="level-right">

            <Button className="fz fz-filter1 large marginless filter-button "
                    color={"default"}
                    isOutlined={true}
                    title={title}
                    aria-label={title}
                    onClick={() => onToggle(sectionKey)}/>
          </div>

        </div>
        <div className={bodyClass}>{children}</div>
      </>
  );
};

export function useToggleSection(keys = [], initiallyHidden = []) {
  const [hiddenSet, setHiddenSet] = useState(() => new Set(initiallyHidden));

  const isHidden = useCallback((key) => hiddenSet.has(key), [hiddenSet]);

  const togglerKey = useCallback((key) => {
    setHiddenSet(prev => {
      const newSet = new Set(prev);
      newSet.has(key) ? newSet.delete(key) : newSet.add(key);
      return newSet;
    });
  }, []);

  return {isHidden, togglerKey};
}

/**
 * Hook to manage collapsible UI sections (e.g., cards, drawers)
 *
 * @param {string[]} keys - list of section keys to initialize
 * @param {string[]} initiallyHidden - optional list of keys that start
 hidden
 */
export function useToggler(keys = [], initiallyHidden = []) {
  const [hiddenMap, setHiddenMap] = useState(() => {
    const map = {};
    keys.forEach(key => {
      map[key] = initiallyHidden.includes(key) ? "is-hidden" : "";
    });
    return map;
  });

  const isHidden = useCallback(
      (key) => hiddenMap[key]?.includes("is-hidden"),
      [hiddenMap]
  );

  const togglerKey = useCallback((key) => {
    setHiddenMap(prev => ({
      ...prev,
      [key]: prev[key]?.includes("is-hidden") ? "" : "is-hidden"
    }));
  }, []);

  return {
    keyBasedClassNameAdditions: hiddenMap,
    togglerKey,
    isHidden
  };
}

export default ToggleSection;
